import { render, staticRenderFns } from "./CompanyDetailDialog.vue?vue&type=template&id=04fb5cd8&scoped=true&"
import script from "./CompanyDetailDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetailDialog.vue?vue&type=style&index=0&id=04fb5cd8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb5cd8",
  null
  
)

export default component.exports